import {createContext, use, useState} from 'react'

// Split the boolean state from the (stable) setter so consumers that only open
// or close the dialog never re-render when the open state changes.
const DialogOpenStateContext = createContext<boolean>(false)
const SetDialogOpenContext = createContext<(isDialogOpen: boolean) => void>(() => {})

/**
 * Simple context that tracks whether a dialog is open or not.
 * Used internally by Conversations to work around issue with having nested Overlays + Dialogs.
 */
export function DialogStateProvider({children}: {children: React.ReactNode}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <SetDialogOpenContext value={setIsDialogOpen}>
      <DialogOpenStateContext value={isDialogOpen}>{children}</DialogOpenStateContext>
    </SetDialogOpenContext>
  )
}

export const useIsDialogOpen = () => use(DialogOpenStateContext)
export const useSetIsDialogOpen = () => use(SetDialogOpenContext)
